/* eslint-disable */
import { createBrowserHistory } from "history";
import React, {useEffect} from "react";
import { isMobile } from "react-device-detect";
import { Route, Router, Switch } from "react-router-dom";
import Alert from "react-s-alert";
import "./assets/css/common/uploadDialog.scss";
import Footer from "./components/common/footer.jsx";
import LoaderComponent from "./components/common/loaderComponent.jsx";
import CommonContainer from "./containers/CommonContainer.jsx";
import { ROUTES } from "./routes/routes";

export const appHistory = createBrowserHistory()
let interval = null

const AppRoutes = (props) => {

  useEffect(() => {
    const detectCookiesSetByBrowser = () => {
      const originalCookie = Object.getOwnPropertyDescriptor(Document.prototype, 'cookie');
      Object.defineProperty(document, 'cookie', {
        get: function() {
          return originalCookie.get.call(document);
        },
        set: function(value) {
          originalCookie.set.call(document, value);
        }
      });
    }

    detectCookiesSetByBrowser() // Only for testing in staging
  }, [])

  useEffect(() => {
    interval = setInterval(() => {
      clearDuplicateHoverEffect()
    }, 1000)
  }, [])

  const clearDuplicateHoverEffect = () => {
    const elements = document.getElementById("zohohc-asap-web-helper-core")
    if (elements) {
      const launcherbox = document.getElementById("zohohc-asap-web-launcherbox")

      if (launcherbox) {
        const svg = document.getElementById("zohohc-asap-sybl-inappweb_idea")
        if (svg) {
          svg.setAttribute("fill", "#526670")
        }
        launcherbox.style.left = "auto";
        launcherbox.style.bottom = "auto";
        launcherbox.style.top = 0;
        launcherbox.style.right = isMobile ? "65px" : "80px";
        launcherbox.style.marginTop = "22px";
        launcherbox.style.boxShadow = "none";
        launcherbox.style.height = "16px";
        launcherbox.style.width = "16px";
        launcherbox.style.borderRadius = "5px";
        launcherbox.style.background = "transparent";
        launcherbox.style.zIndex = 999;
      }

      const parent = elements.children[0]
      const children = parent ? parent.querySelectorAll('[data-id="tooltip"]') : []

      if (parent && children.length) {
        parent.removeChild(parent.firstChild);
        clearInterval(interval);
      }

    }
  }

  const unlisten = appHistory.listen((location, action) => {
    clearDuplicateHoverEffect()
  })

  return <Router history={appHistory}>
    <CommonContainer />
    <LoaderComponent />
    <Alert stack={{ limit: 3 }} />
    <Switch>
      {
        ROUTES.map((route, i) => {
          const Component = route.component(props)
          return <Route
              key={route.id || i}
              exact={route.id !== "Home"}
              path={route.path}
              render={p => <Component {...p} />}
              routeChange={true}
          />
        })
      }
    </Switch>
    <Footer />
  </Router>
}

export default AppRoutes
